export const build = { date:"2026-03-26.2059", stage:"alpha" }
